import styled from "styled-components"
import { desktopTextStyles, FontFamilyRegular } from "./typography.styles"
import Breakpoints from "./breakpoints"

export const EmailContainer = styled.form`
  display: flex;
  justify-content: center;
  position: relative;

  flex-basis: 100%;
  grid-row-start: 2;
  grid-row-end: 3;
  grid-column: 3 / 11;
  margin-bottom: 77px;
  margin-top: 8px;
  flex-direction: column;

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 0px;
    flex-direction: row;
    grid-row: 2;
    margin-bottom: 32px;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 5 / 9;
    margin-bottom: 64px;
    max-height: 46px;
  }
`
export const EmailInput = styled.input`
  box-sizing: border-box;
  ${desktopTextStyles.BodyText16}
  border: 1px solid #FFFFFF;
  width: 100%;
  padding: 10px 0;

  background-color: unset;
  text-align: center;

  margin-bottom: 16px;
  color: var(--white);

  ::placeholder {
    color: var(--white);
  }

  :focus {
    outline: none;
  }

  @media (min-width: ${Breakpoints.md}) {
    text-align: left;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.5);
    color: var(--charcoal);
    background-color: var(--white);
    align-self: stretch;
    margin-bottom: 0;
    margin-top: 0;
    padding-left: 13px;

    ::placeholder {
      color: var(--charcoal);
    }
  }

  opacity: ${props => (props.disabled ? "0.7" : "1")};
`

export const EmailSubmitButton = styled.button`
  ${desktopTextStyles.LinkText}
  line-height: 14px;
  color: var(--white);
  background-color: var(--burnt-orange);
  padding: 16px 32px 16px 32px;
  border: none;
  white-space: nowrap;
  margin: 0;
  opacity: ${props => (props.disabled ? "0.7" : "1")};
`

export const EmailErrorText = styled.p`
  position: absolute;
  top: -16px;
  left: 0px;
  color: var(--burnt-orange);
  ${FontFamilyRegular}
  font-size: 12px;
  font-weight: 500;
  @media (min-width: ${Breakpoints.md}) {
    bottom: -16px;
    top: unset;
  }
`
